import MainLayout from 'components/layout';
import FourGPage from 'pages/4g';
import Adsl from 'pages/adsl';
import Fiber from 'pages/fiber';
import Home from 'pages/home';
import LtePage from 'pages/lte';
import OWA from 'pages/owa';
import AsiaTell from 'pages/tell';
import { Link, createBrowserRouter } from 'react-router-dom';
export const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    handle: {
      crumb: () => <Link to="/">خانه</Link>,
    },
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: '/td-lte',
        element: <LtePage />,
        handle: {
          crumb: () => <Link>LTE</Link>,
        },
      },
      {
        path: '/4g',
        element: <FourGPage />,
        handle: {
          crumb: () => <Link>4G</Link>,
        },
      },
      {
        path: '/owa',
        element: <OWA />,
        handle: {
          crumb: () => <Link>OWA</Link>,
        },
      },
      {
        path: '/asia-tell',
        element: <AsiaTell />,
        handle: {
          crumb: () => <Link>آسیاتل</Link>,
        },
      },
      {
        path: '/fiber',
        element: <Fiber />,
        handle: {
          crumb: () => <Link>آسیاتل</Link>,
        },
      },
      {
        path: '/adsl',
        element: <Adsl />,
        handle: {
          crumb: () => <Link>ADSL+2</Link>,
        },
      },
    ],
  },
]);
